import { Box, Dialog, Stack, Typography, useTheme } from "@mui/material";
import aiHomeIntroPreview from "assets/images/aiHomeIntro.png";
import { Button } from "components/button";
import { CheckCircleIcon } from "components/icons";

const BORDER_GRADIENT =
  "linear-gradient(120deg, #4D25ED, #874FFF, #FF96E2, #ED25C1, #874FFF, #4D25ED)";

interface AiHomeIntroModalProps {
  open: boolean;
  onClose: () => void;
}

export const AiHomeIntroModal = ({ open, onClose }: AiHomeIntroModalProps) => {
  const theme = useTheme();
  const surface = theme.palette.neutral.main;

  return (
    <Dialog
      open={open}
      aria-labelledby="ai-home-intro-title"
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "496px",
          maxWidth: "calc(100% - 64px)",
          m: 0,
          borderRadius: "8px",
          border: "1px solid transparent",
          background: `linear-gradient(${surface}, ${surface}) padding-box, ${BORDER_GRADIENT} border-box`,
          boxShadow:
            "0px 8px 24px 0px rgba(0, 0, 0, 0.08), 0px 2px 8px 0px rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <Stack
        sx={{
          alignItems: "center",
          gap: "16px",
          padding: "24px",
        }}
      >
        <Stack
          direction="row"
          sx={{ alignItems: "center", justifyContent: "center", gap: "8px" }}
        >
          <CheckCircleIcon
            sx={{ fontSize: "20px", color: theme.palette.success.main }}
          />
          <Typography variant="button-large" id="ai-home-intro-title">
            DeskDay AI is now enabled for your account!
          </Typography>
        </Stack>

        <Box
          component="img"
          src={aiHomeIntroPreview}
          alt="Illustration of Ask Helena, AI Copilot and AI Agents in DeskDay"
          sx={{ width: "384px", maxWidth: "100%", display: "block" }}
        />

        <Typography
          variant="body-small"
          sx={{
            textAlign: "center",
            color: theme.palette.lightBg.medium,
          }}
        >
          Explore{" "}
          <Typography variant="button-label" color={theme.palette.lightBg.high}>
            Ask Helena, AI Copilot, and AI Agents
          </Typography>{" "}
          to automate tasks, assist your technicians, and streamline your
          service desk. Experience the power of AI across DeskDay and work
          smarter, faster, and more efficiently.
        </Typography>

        <Button variant="secondary" onClick={onClose}>
          Got it
        </Button>
      </Stack>
    </Dialog>
  );
};
